/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {EquipmentVo} from "./equipment-vo.model";

export class VehicleEquipmentDto extends JSONable {
  uuid: string | undefined;
  equipmentVO: EquipmentVo | undefined;
  installationDate: string | undefined;
  uninstallationDate: string | undefined;
  validFrom: string | undefined;
  validTo: string | undefined;
}
